import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { FieldWrapper } from '../../Form';
import { Grant, Place } from '../../../services/model';

const validationSchema = yup
  .object({
    name: yup.string().required('This is required field'),
    grantId: yup.number().nullable().required('This is required field'),
    placeCodes: yup.array().of(yup.string()).nullable().min(1, 'This is required field'),
  })
  .required();

type Props = {
  grantsData: Grant[];
  placesData: Place[];
  onSubmit?: SubmitHandler<any>;
};

// eslint-disable-next-line
const AddRoleForm = React.forwardRef<HTMLFormElement, Props>(({ grantsData = [], placesData = [], onSubmit = () => {} }, ref) => {
    const { control, handleSubmit } = useForm({
      mode: 'onChange',
      resolver: yupResolver(validationSchema),
      defaultValues: {
        name: '',
        grantId: undefined,
        placeCodes: [],
      },
    });

    return (
      <form onSubmit={handleSubmit(onSubmit)} ref={ref}>
        <FieldWrapper>
          <label htmlFor="name">Name</label>
          <Controller
            name="name"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <InputText id={field.name} className={classNames({ 'p-invalid': fieldState.error })} {...field} />
                {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
              </>
            )}
          />
        </FieldWrapper>
        <FieldWrapper>
          <label htmlFor="grantId">Grant</label>
          <Controller
            name="grantId"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Dropdown
                  id={field.name}
                  options={grantsData}
                  value={field.value}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  showClear
                  className={classNames({ 'p-invalid': fieldState.error })}
                  onChange={(e) => field.onChange(e.value)}
                  placeholder="Select grant"
                />
                {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
              </>
            )}
          />
        </FieldWrapper>

        <FieldWrapper>
          <label htmlFor="placeCodes">Places</label>
          <Controller
            name="placeCodes"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <MultiSelect
                  id={field.name}
                  options={placesData}
                  value={field.value}
                  optionLabel="name"
                  optionValue="code"
                  display="chip"
                  filter
                  showClear
                  className={classNames({ 'p-invalid': fieldState.error })}
                  onChange={(e) => field.onChange(e.value)}
                  placeholder="Select place"
                />
                {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
              </>
            )}
          />
        </FieldWrapper>
      </form>
    );
  },
);

export default AddRoleForm;
